export const DAY_STATUS = {
  SUBMITTED: 1,
  APPROVED: 3,
  REJECTED: 4,
  LOCKED: 5,
} as const;
